import { IonInput, IonItem, IonLabel } from '@ionic/react'
import { useController } from 'react-hook-form'

import type { FieldValues, FieldPath, Control } from 'react-hook-form'

function AccountInput<
  TFieldValues extends FieldValues = FieldValues,
  TFieldName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  name,
  label,
  control,
  placeholder,
}: React.ComponentProps<typeof IonInput> & {
  control: Control<TFieldValues>
  label?: string
  name: TFieldName
}) {
  const { field } = useController<TFieldValues>({ name, control })

  return (
    <IonItem color="secondary">
      <IonLabel position="stacked">{label}</IonLabel>
      <IonInput
        type="text"
        onIonChange={field.onChange}
        value={field.value}
        autocapitalize="off"
        required
        placeholder={placeholder}
      />
    </IonItem>
  )
}

export { AccountInput }
